export enum ESlideTo {
	next = 0,
	previous,
	indexTarget
}